import { useEffect } from 'react';
import { connect } from 'dva';
import ArcGraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import PropTypes from 'prop-types';
import { MAP_LAYER_IDS } from '../../lib/constants';

function GraphicsLayer(props) {
  useEffect(() => {
    let graphicsLayer = new ArcGraphicsLayer({
      id: MAP_LAYER_IDS.content,
      mode: 'on-the-ground',
    });

    graphicsLayer.screenSizePerspectiveEnabled = false;

    props.map.add(graphicsLayer);

    props.dispatch({
      type: 'user/getCurrentUserProfile',
    });
    props.dispatch({
      type: 'userPreferences/getUserPreferencesEffect'
    })

    props.view.whenLayerView(graphicsLayer).then(() => {
      props.dispatch({
        type: 'map/setMapReady',
        payload: true
      });
      // [WIP]: Will store Terrain into state on load
      /* props.dispatch({
        type: 'map/getTerrain',
        payload: '3D'
      }); */
      props.dispatch({
        type: 'historicalImagery/getImageryList'
      })
      props.dispatch({
        type: 'layers/getLayersListEffect',
        callback: () => {
          props.dispatch({
            type: 'collections/getUserCollectionPoll-start',
            callback: () => {
              props.dispatch({
                type: 'collections/getUserCollectionPoll-stop',
              });
              props.dispatch({
                type: 'collections/moreCollectionsLoading',
                payload: false,
              });
            },
          });
          props.dispatch({
            type: 'features/getUserDataPoll-start',
            callback: () => {
              props.dispatch({
                type: 'features/getUserDataPoll-stop'
              });
              props.dispatch({
                type: 'features/moreFeaturesLoading',
                payload: false,
              });
            }             
          });
        }
      });
      props.dispatch({
        type: 'app/setGlobalLoading',
        payload: false,
      });
    });
  }, []);

  return null;
}

GraphicsLayer.propTypes = {
  map: PropTypes.object,
  view: PropTypes.object
}

export default connect(() => ({}))(GraphicsLayer);
